export enum BytesPrefix {
  Byte = 'B',
  KiloByte = 'KB',
  MegaByte = 'MB',
  GigaByte = 'GB',
  TeraByte = 'TB',
}
